import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';

import SuspenseLoader from 'src/components/SuspenseLoader';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

// Dashboards

const AdminDashboard = Loader(
  lazy(() => import('src/content/dashboards/ccs/admin'))
);
const UserDashboard = Loader(
  lazy(() => import('src/content/dashboards/ccs/user'))
);
const Reports = Loader(lazy(() => import('src/content/dashboards/Reports')));


const dashboardsRoutes = [
  {
    path: '',
    element: <AdminDashboard />
  },
  {
    path: 'admin',
    element: <AdminDashboard />
  },
  {
    path: 'user',
    element: <UserDashboard />
  },
  {
    path: 'reports',
    element: <Reports />
  },
  
];

export default dashboardsRoutes;
